<template>
    <div id="demo-basic-card">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="vx-col w-full mt-2 md:w-1/2 pl-0 pl-0">
                    <div class="vx-card mt-2 p-6">
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="component mt-2 text-title-data">
                                    <span> {{ $t('packageUpgrade.data')}}</span>
                                </div>
                                <div class="component number-data mt-2">
                                    <span>{{ eArabic(totalMentioned) }}</span>
                                </div>
                                <div class="component sub-text">
                                    <span>{{ $t('packageUpgrade.toDay')}}</span>
                                </div>
                                <div class="component">
                                    <span v-if="increaseMentioned" class="text" :style="{color: '#28C76F'}">{{percentMentioned || 0}}% </span>
                                    <span v-else class="text" :style="{color: '#F12B2C'}">{{percentMentioned || 0}}% </span>
                                    <span class="sub-text"> {{ $t('overview.comparedToYesterday')}}</span>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/2 w-full">
                                <div id="chart">
                                    <vue-apex-charts
                                    v-if="showRadialChart"
                                    type="radialBar"
                                    height="250"
                                    :options="radialChart.chartOptions"
                                    :series="radialChart.series">
                                    </vue-apex-charts>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-2">
                                <div class="component">
                                    <span class="sub-text">{{ $t('packageUpgrade.thisPeriod')}}</span>
                                </div>
                                <div class="component">
                                    <span class="text-number">{{eArabic(businessPackage.dataUsed)}}</span>
                                </div>
                                <div class="component">
                                    <vs-progress class="block mt-1" :percent="businessPackage.percentDataUsed" color="primary" :height="6"></vs-progress>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/2 w-full mt-2">
                                <div class="component">
                                    <span class="sub-text">{{ $t('packageUpgrade.remaining')}}</span>
                                </div>
                                <div class="component">
                                    <span class="text-number">{{eArabic(businessPackage.remainData)}}</span>
                                </div>
                                <div class="component">
                                    <vs-progress class="block mt-1" :percent="businessPackage.percentRemainData" color="danger" :height="6"></vs-progress>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-2">
                                <div class="component">
                                    <span class="sub-text">{{ $t('packageUpgrade.expired')}}</span>
                                </div>
                                <div class="component" v-if ="businessPackage.countDateExpired > 0">
                                    <span class="text-number">{{eArabic(businessPackage.countDateExpired)}} {{ $t('packageUpgrade.day')}}<span v-if="businessPackage.countDateExpired > 1 && $i18n.locale == 'en'">s</span></span>
                                </div>
                                <div class="component" v-if ="businessPackage.countDateExpired <= 0">
                                    <span class="text-number">{{ $t('packageUpgrade.expired')}}</span>
                                </div>
                                <div class="component">
                                    <vs-progress class="block mt-1" :percent="businessPackage.percentDate" color="warning" :height="6"></vs-progress>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-8">
                                <vs-button @click="userRegisterPackage">{{$t('packageUpgrade.extend')}}</vs-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="vx-col w-full mt-2 md:w-1/2 pr-0 pl-0">
                    <div class="vx-card mt-2 p-6 height-card-static">
                        <div class="vx-row">
                            <div class="vx-col mt-2 md:w-1/2">
                                <span class="text-title-data">{{ $t('packageUpgrade.data')}}</span>
                            </div>
                        </div>
                        <div class="component">
                            <span class="text-day">{{countDays}} {{ $t('packageUpgrade.day')}}<span v-if="countDays> 1 && $i18n.locale == 'en'">s</span></span>
                        </div>
                        <div id="chart">
                            <vue-apex-charts
                            v-if="showWorkChart"
                            type="bar"
                            height="300"
                            :options="chartData.chartOptions"
                            :series="chartData.series">
                            </vue-apex-charts>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';

export default {
    components: {
        VueApexCharts,
        moment
    },
    data(){
        return {
            defaultWords: [],

            increaseMentioned: false,
            percentMentioned: "",
            totalMentioned: null,
            showRadialChart: false,

            //list data top domain
            listTopDomains: [],

            //list data top topic
            listTopTopics: [],

            //list top topic group
            listTopTopicGroups: [],

            //show chart
            showWorkChart: false,

            //show data table
            showTopGroup: false,
            showTopTopic: false,
            showTopDomain: false,

            //progess data
            totalData:"",
            dataUsed: "",
            percentData: null,

            //count day
            countDays: null,

            //business package
            businessPackage: {
                name: null,
                startDate: null,
                expiredDate: null,
                totalData: "",
                percentData: null,
                agvData: null,
                countDateExpired: null,
                percentDate:null,
                remainData: null,
                percentRemainData:null,
                dataUsed: null,
                percentDataUsed:null,
                packageId: null,
            },

            //date range
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() - 29);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            radialChart: {
                series: [],
                chartOptions: {
                    chart: {
                    height: 200,
                    type: 'radialBar',
                    },
                    colors: [],
                    labels: [],
                    plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '18px',
                                show: false
                            },
                            value: {
                                fontSize: '16px',
                                color: '#5E5873'
                            },
                        }
                    }
                    },
                },
            },

            //chart bien dong du lieu
            chartData: {
                series: [],
                chartOptions: {
                    chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    // stackType: '100%'
                    },
                    colors: ['#2F80ED'],
                    responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                        }
                    }
                    }],
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        labels: {
                            showDuplicates:false,
                            formatter: function (val) {
                            if (!val) return val;
                            if (val && isNaN(val)) {
                                let dateSplit = val.split('-'),
                                type = dateSplit[1],
                                dateTemp = moment(dateSplit[0], "YYYYMMDD");

                                if(type === "W")
                                    return `Tuần ${dateTemp.isoWeek()}`;

                                if(type === "M")
                                    return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                                return val.slice(6, 8) + "/" + val.slice(4, 6)
                            }
                            },
                            style: {
                                cssClass: 'text-grey fill-current',
                            },
                        },
                        axisTicks: {
                            show: false
                        },
                        categories: [],
                        tooltip: {
                            enabled: false
                        },
                    },
                    fill: {
                    opacity: 1
                    },
                    legend:{
                        position:'top',
                        show:true,
                        markers: {
                        fillColors: ['#28C76F']
                        }
                    },
                    colors:['#28C76F'],
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        inverseColors: false,
                        gradientToColors: ['#28C76F'],
                        shadeIntensity: 0.5,
                        type: 'horizontal',
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100, 100, 100]
                    },
                    },
                    stroke: {
                    // curve: 'smooth',
                    //dashArray: [0, 8],
                    width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                        2, 2, 2, 2, 2, 2, 2, 2
                        , 2, 2, 2, 2, 2, 2, 2, 2],
                    },
                },
            }
        }
    },
    methods:{
        getTopDomain: function(conditions){
            this.$processor.post('/user-data/get-top-domain', conditions).then((res) => {
                let index = 0;
                this.listTopDomains = res.data.slice(0,5).map(el  => {
                    let countPost = el.countPost;
                    let arrPositive = this.percentClassification(el.countPositive, countPost);
                    let arrNeutral = this.percentClassification(el.countNeutral, countPost);
                    let arrNegative = this.percentClassification(el.countNegative, countPost);
                    let object = {};
                    index++;
                    object['name'] = el.domain;
                    object['url'] = el.url;
                    object['countData'] = el.countPost;
                    object['value'] = el.countPost;
                    object['stt'] = index;
                    object['countPositive'] = arrPositive;
                    object['countNeutral'] = arrNeutral;
                    object['countNegative'] = arrNegative;
                    return object;
                });
                this.showTopDomain = true;
            })
        },
        percentClassification: function(countPost, totalPost){
            let arr = [];
            let result = ((countPost /totalPost) * 10).toFixed(0);
            for (let i = 0; i < result; i++){
                arr.push(i);
            }
            return arr;
        },
        getMentionTopic: function(conditions) {
        this.$processor
            .post("/user-data/get-mention-topic", conditions)
            .then(topic => {
                topic.data = topic.data.sort(function(a, b) {
                    if (a.countMention > b.countMention) return -1;
                    if (a.countMention < b.countMention) return 1;
                    return 0;
                });
                let index = 0;
                this.listTopTopics = topic.data.map(el => {
                    let countMention = el.countMention;
                    let arrPositive = this.percentClassification(el.totalPositive, countMention);
                    let arrNeutral = this.percentClassification(el.totalNeutral, countMention);
                    let arrNegative = this.percentClassification(el.totalNegative, countMention);
                    let object = {};
                    object['stt'] = index++;
                    object['name']= el.topicName;
                    object['value'] = el.countMention;
                    object['countPositive'] = arrPositive;
                    object['countNeutral'] = arrNeutral;
                    object['countNegative'] = arrNegative;
                    return object;
                });
                this.showTopTopic = true;
            });
        },
        getDataWorkChart: function(conditions) {
            this.showWorkChart = false;
            let that = this;
            this.$processor
                .post("/user-data/get-work-by-day", conditions)
                .then(res => {
                res.data.mentionByDays = this.optimizedChart(res.data.mentionByDays);

                that.workChartData = res.data;
                let mentionByDays = {
                    name: 'Dữ liệu',
                    data: that.workChartData.mentionByDays.map(x => {
                    return x.totalData;
                    })
                };
                let countData = 0;
                mentionByDays.data.forEach(count => {
                    countData = countData + count;
                })
                this.businessPackage.agvData = (countData/30).toFixed(0);
                that.chartData.series = [];
                that.chartData.chartOptions.xaxis.categories = [];
                that.chartData.chartOptions.xaxis.categories.push(
                    ...that.workChartData.mentionByDays.map(x => {
                        return x.stringDate
                    })
                );
                that.chartData.series.push(mentionByDays);
                that.showWorkChart = true;
                that.$vs.loading.close();
            });
        },
        optimizedChart: function (data){
            data = data.sort(function(a,b){
                return parseInt(a.stringDate) - parseInt(b.stringDate)
            })
            data.map(item => {
                let date = moment(item.stringDate, 'YYYYMMDD');
                item.month = date.format('Y') + date.format('M');
                item.week = date.isoWeek();
                item.day = date.format('D');
                return item;
            })

            let result = [];
            data.reduce(function(res, value) {
            if(data.length <= 21) {
                if (!res[value.day]) {
                res[value.day] = {day: value.day, stringDate: value.stringDate, totalData: 0};
                result.push(res[value.day])
                }
                res[value.day].totalData += value.totalData;
                res[value.day].stringDate += "-D";
                return res;
            }
            if( 14 < data.length && data.length < 62){
                if (!res[value.week]) {
                res[value.week] = {week: value.week, stringDate: value.stringDate, totalData: 0};
                result.push(res[value.week])
                }
                res[value.week].totalData += value.totalData;
                res[value.week].stringDate += "-W";
                return res;
            }
            else if(data.length > 62){
                if (!res[value.month]) {
                res[value.month] = {month: value.month, stringDate: value.stringDate, totalData: 0};
                result.push(res[value.month])
                }
                res[value.month].totalData += value.totalData;
                res[value.month].stringDate += "-M";
                return res;
            }
            }, {});
            data = result;
            return data;

        },
        getTopTopicGroup: function(conditions){
            this.$processor.post('/user-data/get-top-topic-group', conditions).then((res) => {
                let index = 0;
                this.listTopTopicGroups = res.data.slice(0,5).map(el  => {
                    let countPost = el.countData;
                    let arrPositive = this.percentClassification(el.countPositive, countPost);
                    let arrNeutral = this.percentClassification(el.countNeutral, countPost);
                    let arrNegative = this.percentClassification(el.countNegative, countPost);
                    let object = {};
                    index++;
                    object['name'] = el.topicGroupName;
                    object['countData'] = el.countData;
                    object['value'] = el.countData;
                    object['stt'] = index;
                    object['countPositive'] = arrPositive;
                    object['countNeutral'] = arrNeutral;
                    object['countNegative'] = arrNegative;
                    return object;
                });
                this.showTopGroup = true;
            })
        },
        getDataUsing: function(){
            let info = localStorage.getItem('userInfo');
            let user = JSON.parse(info);
            let columnName = 'totalData/' + user.id;
            const payload = {
                column: columnName
            }
            this.$processor.post('/package-using/find-by-column', payload).then((res) => {
                let totalData = res.data.totalData;
                let dataUsed = totalData - res.data.registerData;
                this.businessPackage.totalData = totalData;
                this.businessPackage.dataUsed = dataUsed;
                this.businessPackage.percentData = parseInt(((dataUsed/totalData) * 100).toFixed(0));
            })
        },
        getUsingPackage: function(){
            this.$business.post('/user-package/using-package', {}).then((res) => {
                let businessPackage = res.data;
                let countDate = this.countExpiredDateRange(businessPackage.expiredDate, new Date());
                this.businessPackage.countDateExpired = countDate;
                let number = (((30 - countDate) / 30) * 100).toFixed(0)
                this.businessPackage.remainData = businessPackage.remainData;
                let percentRemainData = ((businessPackage.remainData / businessPackage.totalData) *100).toFixed(0);
                this.businessPackage.percentRemainData = parseInt(percentRemainData);
                let dataUsed = businessPackage.totalData - businessPackage.remainData;
                this.businessPackage.dataUsed = dataUsed;
                let percentDataUsed = ((dataUsed / businessPackage.totalData) * 100).toFixed(0)
                this.businessPackage.percentDataUsed = parseInt(percentDataUsed);
                this.businessPackage.percentDate = parseInt(number);
                this.businessPackage.startDate = moment(businessPackage.startDate).format('DD/MM/YYYY');
                this.businessPackage.expiredDate = moment(businessPackage.expiredDate).format('DD/MM/YYYY');
                this.businessPackage.name = businessPackage.businessPackage.name;
                this.businessPackage.packageId = businessPackage.businessPackage.id;
            })
        },
        backToPackageManage(){
            this.$router.push('/user/package/manage').catch(() => {});
        },
        checkRegisterPackage: function(){
            return new Promise((resolve, reject) => {
            this.$business.get('user-package/user-all-register-package').then((res) => {
                const result = res.data.filter(el => el.status == 0);
                if(result.length > 0){
                return this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: this.$t('packageUpgrade.titlePackage'),
                    accept: this.backToPackageManage,
                    text: `${this.$t('packageUpgrade.text1')} ` + ` ${result[0].businessPackage.name} ` + ` ${this.$t('packageUpgrade.text2')}` ,
                    acceptText: this.$t('packageUpgrade.acceptText'),
                    cancelText: this.$t('packageUpgrade.cancelText'),
                })
                }
                resolve();
            })
            })
        },
        userRegisterPackage() {
            let packageId = this.businessPackage.packageId;
            this.checkRegisterPackage().then(() => {
            this.$business.post('/user-package/register', {packageId: packageId}).then((res) => {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: this.$t('packageUpgrade.titleSuccess'),
                    accept: this.backToPackageManage,
                    text: this.$t('packageUpgrade.text5'),
                    acceptText: this.$t('packageUpgrade.acceptText'),
                    cancelText: this.$t('packageUpgrade.cancelText'),
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.message || err.response.error_description || err.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
            });
            });
        },
        countExpiredDateRange: function(fromDate, toDate){
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round((firstDate - secondDate) / oneDay);
            return diffDays;
        },
        countDateRange: function(fromDate, toDate){
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.countDays = diffDays;
            return diffDays;
        },
        eArabic: function(x){
            return x ? x.toLocaleString('de-DE') : ""; 
        },
        getMention(conditions) {
            let that = this;
            this.showRadialChart = false;
                this.showDonutChartSource = false;
                this.$processor
                    .post("/user-data/get-mention", conditions)
                    .then(mention => {
                    this.mention = mention.data;

                this.totalMentioned = this.mention.totalMentioned;
                this.percentData = ((this.mention.totalMentioned / this.mention.countAllData) * 100).toFixed(0);
                this.percentMentioned = null;
                if (this.mention.countAllTo || this.mention.countAllFrom) {
                    if (this.mention.countAllTo > this.mention.countAllFrom) {
                    this.increaseMentioned = true;
                    this.percentMentioned = "+" +
                        (
                        ((this.mention.countAllTo - this.mention.countAllFrom) /
                            (this.mention.countAllFrom != 0
                            ? this.mention.countAllFrom
                            : 1)) *
                        100
                        ).toFixed(2);
                    } else {
                    this.percentMentioned = "-" +
                        (
                        ((this.mention.countAllFrom - this.mention.countAllTo) /
                            (this.mention.countAllTo != 0
                            ? this.mention.countAllTo
                            : 1)) *
                        100
                        ).toFixed(2);
                    }

                }
                that.radialChart.chartOptions.colors = ['#28C76F'];
                that.radialChart.chartOptions.labels = [];
                let percentData = ((this.mention.totalMentioned / this.mention.countAllFrom) * 100).toFixed(0);
                that.radialChart.series = [percentData]
                that.showRadialChart = true;
                });
        },
        initScreen(){
            let fromDate =  this.dateRange.startDate;
            let toDate = this.dateRange.endDate;
            const payload = {
                from: fromDate,
                to: toDate
            }

            let now = new Date();
            let endDate = now.setHours(23, 59, 59);
            let startDate = now.setHours(0, 0, 0);
            const payloadDay = {
                from: new Date(startDate),
                to: new Date(endDate)
            }
            this.countDateRange(fromDate, toDate);
            this.getTopDomain(payloadDay);
            this.getMentionTopic(payloadDay);
            this.getDataWorkChart(payload);
            this.getTopTopicGroup(payloadDay);
            // this.getDataUsing();
            this.getUsingPackage();
            this.getMention(payload);
        }
    },
    created(){
        this.initScreen();
        this.$eventBus.$on('i18n', () =>{
            this.initScreen();
        })
    }
}
</script>
<style scoped>
.text-title-data {
    font-size: 18px;
    color: #5E5873;
}
.number-data {
    font-size: 42px;
    color: #5E5873;
    font-weight: bold;
}
.sub-text {
    font-size: 14px;
    color: #6E6B7B;
}
.percent-up {
    color: #28C76F;
    font-size: 14px;
}
.percent-down {
    font-size: 14px;
    color: #EA5455;
}
.min-height-card{
    min-height: 308px;
}
.text-day {
    font-size: 14px;
    color: #B9B9C3;
}
.text-number {
    font-size: 24px;
    color: 5E5873;
    font-weight: bold;
}
.height-card-static{
    height: 417px;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, .5, .5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -.24s
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -.12s
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
.margin-top{
    margin-top: -28px;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px
  }

  50%, 100% {
    top: 16px;
    height: 4px
  }
}
</style>
